// Dev defaults to local; override per-env in .env files if needed.
// On prod build the URL resolves to the public api domain.
const API_BASE_URL: string =
  import.meta.env.VITE_API_BASE_URL ??
  (import.meta.env.PROD
    ? "https://api.shreeksakn.com/api"
    : "http://localhost:8600/api");

// Base URL of the customer-facing site (apps/landing). Used to build
// "View on site" deep links from the admin dashboard. Override via
// VITE_PUBLIC_WEB_URL in env files.
const PUBLIC_WEB_URL: string =
  import.meta.env.VITE_PUBLIC_WEB_URL ??
  (import.meta.env.PROD
    ? "https://shreeksakn.com"
    : "http://localhost:4321");

export { API_BASE_URL, PUBLIC_WEB_URL };
